var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 77,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2952,
    y: 1726,
    width: 69,
    height: 77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2952,
    y: 1725,
    width: 68,
    height: 68
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2952,
    y: 1725,
    width: 68,
    height: 68
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2952,
    y: 1725,
    width: 68,
    height: 68
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2952,
    y: 1735,
    width: 68,
    height: 68
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2952,
    y: 1735,
    width: 68,
    height: 68
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2952,
    y: 1735,
    width: 68,
    height: 68
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2952 -1726)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5049 44.9291 13.7846 25.2129 16.7451 22.2517 33.5049 39.008 50.2605 22.2524 53.2211 25.2129 33.5049 44.9291Z",
    stroke: "#F5F6FA",
    strokeWidth: 0.0136286,
    fill: "#F5F6FA",
    transform: "matrix(1.01492 0 0 1 2952 1726)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5049 44.9291 13.7846 25.2129 16.7451 22.2517 33.5049 39.008 50.2605 22.2524 53.2211 25.2129 33.5049 44.9291Z",
    stroke: "#F5F6FA",
    strokeWidth: 0.0136286,
    fill: "#F5F6FA",
    transform: "matrix(1.01492 0 0 1 2952 1736)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M2953.5 1762C2953.5 1743.5 2968.27 1728.5 2986.5 1728.5 3004.73 1728.5 3019.5 1743.5 3019.5 1762 3019.5 1780.5 3004.73 1795.5 2986.5 1795.5 2968.27 1795.5 2953.5 1780.5 2953.5 1762Z",
    stroke: "#F5F6FA",
    strokeWidth: 3.4375,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.5e4c7fdf6e58eced35cbf2645007e735.svg";
export { ForwardRef as ReactComponent };